import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-400">
        <Loader2 className="animate-spin mr-2" /> Checking session…
      </div>
    );
  }

  if (!user || !user.email) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
